module.exports = __webpack_public_path__ + "img/right.6b5a780c.svg";